import { Button } from '@warp-ds/react';

import type { ReactNode } from 'react';

import styles from '../FrontPageModal.module.css';

interface FrontPageModalFooterProps {
    onClose: () => void;
    children?: ReactNode;
}

export const FrontPageModalFooter = ({ onClose }: FrontPageModalFooterProps) => (
    <footer className={styles.modal__footer}>
        <Button primary fullWidth type="button" onClick={onClose}>
            Bruk
        </Button>
    </footer>
);
